module.exports = __webpack_public_path__ + "img/signup-group-2.062a2692.png";